import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import MentionsLegales from "./pages/MentionsLegales";
import Confidentialite from "./pages/Confidentialite";
import AdminLogin from "./pages/AdminLogin";
import AdminContacts from "./pages/AdminContacts";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "./components/CookieBanner";
import { initGA } from "./lib/analytics";

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<Confidentialite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminContacts />} />
        </Routes>
        <CookieBanner />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
